import { Link } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { SeoHead } from "@/components/SeoHead"
import { MarketingLayout } from "@/components/marketing/MarketingLayout"
import { Section } from "@/components/marketing/sections/Section"

const DESCRIPTION =
  "Thanks for applying to the FullCast Podcast Growth Partnership. We've received your application and will be in touch."

export default function ThankYou() {
  return (
    <MarketingLayout>
      <SeoHead title="Thank you" description={DESCRIPTION} noindex />

      <Section containerClassName="max-w-2xl">
        <h1 className="display-2">Thank you — we've got your application</h1>
        <p className="mt-5 text-lg text-ink-body">
          We appreciate you taking the time to share where your business and your
          podcast stand today. We read every application personally.
        </p>
        <p className="mt-4 text-ink-muted">
          If it looks like a strong fit for the FullCast Podcast Growth
          Partnership, we'll reach out by email about next steps. In the meantime,
          feel free to explore how the partnership works.
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Button asChild size="lg">
            <Link href="/#offer">See how the partnership works</Link>
          </Button>
          <Button asChild variant="secondary" size="lg">
            <Link href="/">Back to home</Link>
          </Button>
        </div>
      </Section>
    </MarketingLayout>
  )
}
